import io from 'socket.io-client'
import { url } from '@/config/url_config'
export default{
  install (Vue, options) {
    Vue.prototype.socket = io(url)
  }
}



// WEBPACK FOOTER //
// ./src/utils/socket.js